import { useState } from 'react';

const IconPhone = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.5 19.79 19.79 0 01.01 4.82 2 2 0 012 2.62h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 10.5a16 16 0 006.29 6.29l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
  </svg>
);

const IconMail = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);

const IconMap = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

export default function Contact() {
  const [form, setForm] = useState({ nombre: '', telefono: '', producto: '', mensaje: '' });
  const [sent, setSent] = useState(false);

  const handleChange = (e) =>
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(`Consulta de ${form.nombre} - DAET`);
    const body = encodeURIComponent(
      `Nombre: ${form.nombre}\nTeléfono: ${form.telefono}\nProducto de interés: ${form.producto}\n\nMensaje:\n${form.mensaje}`
    );
    window.location.href = `mailto:aceroseconomicosdetepa@gmail.com?subject=${subject}&body=${body}`;
    setSent(true);
  };

  return (
    <section id="contacto" className="contact">
      <div className="container">
        <div className="section-header">
          <p className="section-overline">Hablemos</p>
          <h2 className="section-title dark">Contáctanos</h2>
          <div className="section-divider" />
        </div>

        <div className="contact-grid">
          <div className="contact-info">
            <h3 className="contact-info-title">Información de Contacto</h3>
            <p className="contact-info-sub">
              Visítanos en nuestras instalaciones o comunícate con nosotros para
              cotizaciones, precios por volumen y disponibilidad de producto.
            </p>

            <div className="contact-item">
              <div className="contact-icon-box">
                <IconMap />
              </div>
              <div>
                <p className="contact-item-label">Dirección</p>
                <p className="contact-item-value">
                  Bertha Gutiérrez Padilla #1650<br />
                  Cuatro Caminos, Tepatitlán de Morelos, Jal.
                </p>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon-box">
                <IconPhone />
              </div>
              <div>
                <p className="contact-item-label">Teléfono</p>
                <p className="contact-item-value">378 145 5022</p>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon-box">
                <IconMail />
              </div>
              <div>
                <p className="contact-item-label">Correo</p>
                <p className="contact-item-value">aceroseconomicosdetepa@gmail.com</p>
              </div>
            </div>

            <a
              href="https://wa.me/523781455022?text=Hola%2C%20me%20interesa%20cotizar%20materiales%20de%20acero."
              target="_blank"
              rel="noopener noreferrer"
              className="contact-wa-btn"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              Escríbenos por WhatsApp — +52 378 145 5022
            </a>

            <div style={{
              marginTop: '24px',
              background: 'var(--dark)',
              padding: '24px',
              borderLeft: '4px solid var(--accent)'
            }}>
              <p style={{
                fontFamily: 'var(--font-heading)',
                fontSize: '13px',
                letterSpacing: '2px',
                textTransform: 'uppercase',
                color: 'var(--accent)',
                marginBottom: '8px'
              }}>
                Horario de atención
              </p>
              <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.6)', lineHeight: '1.8' }}>
                Lunes – Viernes: 8:30 am – 5:00 pm<br />
                Sábado: 8:30 am – 2:00 pm<br />
                Domingo: Cerrado
              </p>
            </div>
          </div>

          <div className="contact-form-wrapper">
            <h3 className="contact-form-title">Solicitar Cotización</h3>
            <p className="contact-form-sub">
              Completa el formulario y nos pondremos en contacto contigo.
            </p>

            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="nombre">Nombre</label>
                  <input
                    id="nombre"
                    name="nombre"
                    type="text"
                    placeholder="Tu nombre"
                    value={form.nombre}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="telefono">Teléfono</label>
                  <input
                    id="telefono"
                    name="telefono"
                    type="tel"
                    placeholder="Tu número"
                    value={form.telefono}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="producto">Producto de interés</label>
                <select
                  id="producto"
                  name="producto"
                  value={form.producto}
                  onChange={handleChange}
                >
                  <option value="">Selecciona un producto</option>
                  <option>Viga</option>
                  <option>Varilla</option>
                  <option>Angulos</option>
                  <option>PTR</option>
                  <option>Tubo</option>
                  <option>Moiten</option>
                  <option>Lámina para Techo</option>
                  <option>Lámina Negra</option>
                  <option>Soleras</option>
                  <option>Cuadros</option>
                  <option>Otro / Varios</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="mensaje">Mensaje</label>
                <textarea
                  id="mensaje"
                  name="mensaje"
                  placeholder="Describe lo que necesitas: medidas, cantidades, etc."
                  value={form.mensaje}
                  onChange={handleChange}
                  required
                />
              </div>

              <button type="submit" className="form-submit">
                Enviar Consulta
              </button>

              {sent && (
                <div className="form-success">
                  ✓ Se abrió tu cliente de correo. ¡Gracias por contactarnos!
                </div>
              )}
            </form>
          </div>
        </div>

        <div className="contact-map">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5527.101171683014!2d-102.77576690000001!3d20.788667699999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x84292945e84bee5f%3A0xd4b7e81bbc8958e9!2sDAET%20ACEROS%20ECONOMICOS%20DE%20TEPA!5e1!3m2!1sen!2smx!4v1780420706274!5m2!1sen!2smx"
            width="100%"
            height="420"
            style={{ border: 0, display: 'block' }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Ubicación DAET Aceros Económicos de Tepa"
          />
        </div>
      </div>
    </section>
  );
}
